import {
  PUBLIC_SANITY_DATASET,
  PUBLIC_SANITY_STUDIO_URL
} from "$env/static/public";

export const dataset = PUBLIC_SANITY_DATASET || "ishavskraft-001";
export const projectId = "n5xeg4df";
export const apiVersion = "2024-03-15"; // "2022-06-30";
export const studioUrl = PUBLIC_SANITY_STUDIO_URL || "https://ishavskraft.sanity.studio";
